import { Stack, Typography } from "@mui/material";
import { icons } from "assets/AssetHelper";
import dayjs from "dayjs";

export const detailsData = ({ data, t }) => {
  const quantity = data?.city_variant?.reduce(
    (acc, current) => acc + current?.count_on_hand,
    0,
  );
  return [
    {
      head: t("products.label_general_details"),
      icon: icons?.details,
      details: [
        {
          label: t("products.col_vendor"),
          name: data?.store?.name,
          width: "50%",
        },
        {
          label: t("products.label_sku"),
          name: data?.sku,
          width: "35%",
        },
        {
          label: t("products.label_select_option_type"),
          name: (
            <Stack direction="row">
              {data?.optionTypesFilter?.map((option, i) => (
                <Typography>
                  {option?.name}
                  {i < data?.optionTypesFilter.length - 1 && "/"}
                </Typography>
              ))}
            </Stack>
          ),
        },
      ],
    },
    {
      head: t("products.label_prices"),
      icon: icons?.fees,
      details: [
        {
          label: t("products.col_price"),
          name: data?.price,
          width: "50%",
        },
        {
          label: t("products.col_price_after_discount"),
          name: data?.price_after_discount,
          width: "35%",
        },
        {
          label: t("products.col_quantity"),
          name: quantity,
          width: "20%",
        },
      ],
    },
    {
      head: t("products.label_dimensions"),
      icon: icons?.dimensions,
      details: [
        {
          label: t("products.label_width"),
          name: data?.width,
          width: "50%",
        },
        {
          label: t("products.label_height"),
          name: data?.height,
          width: "35%",
        },
        {
          label: t("products.label_length"),
          name: data?.length,
          width: "50%",
        },
        {
          label: t("products.label_weight"),
          name: data?.weight,
          width: "35%",
        },
        {
          label: t("products.label_volume"),
          name: data?.volume,
          width: "35%",
        },
      ],
    },
    {
      head: t("vendors.dates"),
      icon: icons?.dates,
      details: [
        {
          label: t("details.created_at"),
          name: dayjs(data?.created_at).format("DD-MM-YYYY HH:MM a"),
          width: "50%",
        },
        {
          label: t("details.updated_at"),
          name: dayjs(data?.updated_at).format("DD-MM-YYYY HH:MM a"),
          width: "35%",
        },
      ],
    },
  ];
};
